(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  window.onscroll = function () {
    checkScroll()
  }

  // Navbar code

  var navbarWrapper = document.getElementById('navbar-wrapper')
  var navbar = document.getElementById('navbar')
  var navbarSpacer = document.getElementById('navbar-spacer')
  var stickyPosition = navbarWrapper.offsetTop


  function checkScroll() {
    if (window.pageYOffset >= stickyPosition) {
      navbarWrapper.classList.add('fixed')
      navbarWrapper.classList.add('top-0')
      navbarWrapper.classList.add('left-0')
      navbarWrapper.classList.add('w-full')
      navbar.classList.add('container')

      navbarSpacer.style.height = "0px"
    } else {
      navbarWrapper.classList.remove('fixed')
      navbarWrapper.classList.remove('top-0')
      navbarWrapper.classList.remove('left-0')
      navbarWrapper.classList.remove('w-full')
      navbar.classList.remove('container')

      navbarSpacer.style.height = ''
    }
  }

  // Sublist code
  var menuItems = document.querySelectorAll('.has-submenu')
  var timer
  Array.prototype.forEach.call(menuItems, function (el, i) {
    //  el.addEventListener("click", function(event){
    // 	this.classList.add("open");
    //    this.setAttribute('aria-expanded', "true");
    // 	clearTimeout(timer);
    //    // setTimeout(()=> {
    //      document.querySelector(".has-submenu.open").querySelector('ul').style.transform = 'translateY(0px)';
    //      document.querySelector(".has-submenu.open").querySelector('ul').style.top = navbarWrapper.offsetTop + navbarWrapper.getBoundingClientRect().height - 1 + 'px';
    //    // }, 10)
    // });
    // el.addEventListener("mouseout", function(event){
    // 	timer = setTimeout(function(event){
    //      clearTimeout(timer);
    //      document.querySelector(".has-submenu.open").setAttribute('aria-expanded', "false");
    // 		document.querySelector(".has-submenu.open").classList.remove("open");
    // 	}, 300);
    // });
    // Handle keyboard/click navigation
    el.querySelector('button').addEventListener('click', function (event) {
      if (this.parentNode.className.indexOf('open') === -1) {
        this.parentNode.classList.add('open')
        this.parentNode.setAttribute('aria-expanded', 'true')
        clearTimeout(timer)
        // setTimeout(()=> {
        document.querySelector('.has-submenu.open').querySelector('ul').style.transform = 'translateY(0px)'
        el.querySelector('#menu').style.height = '0px'
        el.querySelector('#close').style.height = ''
        //  document.querySelector(".has-submenu.open").querySelector('ul').style.top = navbarWrapper.offsetTop + navbarWrapper.getBoundingClientRect().height - 1 + 'px';
        // }, 10)
      } else {
        this.parentNode.classList.remove('open')
        this.parentNode.setAttribute('aria-expanded', 'false')
        this.parentNode.querySelector('ul').style.transform = ''
        el.querySelector('#menu').style.height = ''
        el.querySelector('#close').style.height = '0px'
      }
      event.preventDefault()
      return false
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal-popup"] && !Shopify.designMode) return;
  try {
    
window.setTimeout(()=> {
  if(localStorage.getItem('hideModals') !== 'true') {
    MicroModal.show('modal-1');
  }
}, 5000)

  } catch(e) { console.error(e); }
})();
})();
